import { useEffect } from "react";
import { useRoute, useLocation } from "wouter";

export default function SlugLandingPage() {
  const [, params] = useRoute("/:slug");
  const [, navigate] = useLocation();
  const slug = params?.slug ?? "";

  useEffect(() => {
    if (!slug) {
      navigate("/");
      return;
    }

    fetch(`/api/referrals/resolve-slug?slug=${encodeURIComponent(slug.toLowerCase())}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.valid && data.referralCode) {
          // Store referral code under same key as existing ReferralAutoApply
          // so the existing apply flow picks it up automatically after signup.
          // Note: if the user also manually enters a code at signup, the manual
          // code takes precedence (handled server-side: already-used guard).
          localStorage.setItem("tpt_referral_code", data.referralCode);
          localStorage.setItem("tpt_referrer_company", data.companyName || "");
        }
        navigate("/");
      })
      .catch(() => navigate("/"));
  }, [slug]);

  return (
    <div className="h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-3">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-sm text-muted-foreground">Just a moment...</p>
      </div>
    </div>
  );
}
